export default "__VITE_ASSET__BZiRnrol__"